import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]
  static values = {
    customProperties: Object,
    availableFields: Array
  }

  connect() {
    this.rowIndex = 0
    this.renderExistingRows()
  }

  escapeHtml(text) {
    if (text == null) return ''
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }

  renderExistingRows() {
    // Converting the custom properties object to array.
    if (this.customPropertiesValue && Object.keys(this.customPropertiesValue).length > 0) {
      Object.entries(this.customPropertiesValue).forEach(([key, property], index) => {
        this.addRowWithData(property, index)
        this.rowIndex = index + 1
      })
    }
  }

  addRow(event) {
    event.preventDefault()
    this.addRowWithData({}, this.rowIndex)
    this.rowIndex++
  }

  addRowWithData(data = {}, index) {
    const row = document.createElement('div')
    row.className = "custom-property-row block text-sm text-gray-700 mt-6 pt-4 border-t border-gray-200 first:mt-0 first:pt-0 first:border-t-0 last:mb-4"
    row.dataset.customPropertiesRowIndex = index
    row.innerHTML = this.customPropertyFields(index, data)

    this.containerTarget.appendChild(row)
  }

  removeRow(event) {
    event.preventDefault()
    const row = event.target.closest('.custom-property-row')
    if (row) {
      row.remove()
      this.reindexRows()
    }
  }

  reindexRows() {
    const rows = this.containerTarget.querySelectorAll('.custom-property-row')
    rows.forEach((row, newIndex) => {
      row.dataset.customPropertiesRowIndex = newIndex

      const inputs = row.querySelectorAll('input, select')
      inputs.forEach(input => {
        if (input.name && input.name.includes('[custom_properties]')) {
          input.name = input.name.replace(
            /\[custom_properties\]\[\d+\]/,
            `[custom_properties][${newIndex}]`
          )
        }
      })
    })

    this.rowIndex = rows.length
  }

  customPropertyFields(index, data) {
    const availableFields = this.availableFieldsValue || []
    const propertyName = this.escapeHtml(data.property_name)
    const defaultValue = this.escapeHtml(data.default_value)

    return `
      <div class="grid grid-cols-10 gap-3 mt-2">
        <div class="col-span-9">
          <div class="grid grid-cols-2 gap-3">
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">Property Name</label>
              <input
                type="text"
                name="data_destination[configuration_attributes][configurable_attributes][custom_properties][${index}][property_name]"
                class="form-text"
                value="${propertyName}"
                required
              />
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">Default Value</label>
              <input
                type="text"
                name="data_destination[configuration_attributes][configurable_attributes][custom_properties][${index}][default_value]"
                class="form-text"
                value="${defaultValue}"
                required
              />
            </div>
          </div>
          <div class="mt-3">
            <label class="block text-sm font-medium text-gray-700 mb-1">Source Field</label>
            <select
              name="data_destination[configuration_attributes][configurable_attributes][custom_properties][${index}][source_field]"
              data-controller="search-select"
            >
              <option value="">Select a field</option>
              ${availableFields.map(field => {
      const selected = data.source_field === field.value || data.source_field === field.label
      return `<option value="${this.escapeHtml(field.value)}"${selected ? ' selected' : ''}>${this.escapeHtml(field.label)}</option>`
    }).join('')}
            </select>
          </div>
        </div>
        <div class="col-span-1 flex items-center justify-center">
          <button
            type="button"
            data-action="click->custom-properties#removeRow"
            class="p-2 text-red-600 hover:text-red-800 hover:bg-red-50 rounded transition-colors"
            title="Remove property"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
            </svg>
          </button>
        </div>
      </div>
    `
  }
}
